import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'Mensagens de E-mail',
  labels: {
    view_full_message: 'Ver mensagem completa',
    status: 'Estado:',
    on: 'Ativo',
    off: 'Inativo',
    next_send: 'Próximo envio: {{date}}.',
  },
  descriptions: {
    welcome:
      'Enviado uma vez quando um cliente subscreve os seus emails de marketing, exceto inscrições através do formulário da sua loja online. Um cliente recebe apenas um entre Boas-vindas, Boas-vindas ao clube de membros e Oferta de lançamento.',
    welcome_members_club:
      'Enviado uma vez quando alguém se inscreve através do formulário da sua loja online e não existe um código promocional de inscrição configurado, ou adere à sua lista de membros VIP. Um cliente recebe apenas um entre Boas-vindas, Boas-vindas ao clube de membros e Oferta de lançamento.',
    storefront_promo:
      'Enviado uma vez quando alguém se inscreve através do formulário da sua loja online e existe um código promocional de inscrição configurado. O email inclui o código promocional pessoal da pessoa.',
    launch_deal:
      'Enviado uma vez aos seus clientes importados, 30 minutos depois de o seu restaurante entrar em funcionamento. Os clientes que já receberam Boas-vindas ou Boas-vindas ao clube de membros são ignorados.',
    we_miss_you:
      'Enviado aos subscritores cuja última encomenda foi há mais de 45 dias. Verificado todas as manhãs; um cliente recebe-o no máximo uma vez a cada 45 dias.',
    happy_friday:
      'Enviado a todos os subscritores às 08:00 UTC na primeira sexta-feira de cada mês par (fevereiro, abril, junho, agosto, outubro, dezembro).',
    lazy_sunday:
      'Enviado a todos os subscritores às 08:00 UTC no primeiro domingo de cada mês ímpar (janeiro, março, maio, julho, setembro, novembro).',
    loyalty_program:
      'Enviado quando o saldo de cashback de um cliente atinge o mínimo que pode gastar. Um cliente recebe-o no máximo uma vez a cada 30 dias.',
    you_might_also_like:
      'Enviado 3 dias após uma encomenda com pelo menos 2 unidades do mesmo artigo com preço igual ou superior a 6,00, recomendando um dos seus artigos mais populares. Um cliente recebe-o no máximo uma vez a cada 30 dias.',
  },
  tiles: {
    sends_count: 'Mensagens Enviadas',
    delivery_rate: 'Taxa de Entrega',
    delivered_suffix: 'entregues',
    open_rate: 'Taxa de Abertura',
    opened_suffix: 'abertas',
    click_rate: 'Taxa de Cliques',
    clicked_suffix: 'clicadas',
    spam_report_rate: 'Taxa de Spam',
    spam_reports_suffix: 'denúncias',
    unsubscribe_rate: 'Taxa de Cancelamento',
    unsubscribes_suffix: 'cancelamentos',
  },
  toasts: {
    failed_to_update_status: 'Erro ao atualizar estado',
    failed_to_load_data: 'Erro ao carregar dados',
  },

  preview_modal: {
    title: 'Pré-visualização do Modelo',
    labels: {
      subject: 'Assunto:',
      close: 'Fechar',
    },
    toasts: {
      failed_to_load_data: 'Erro ao carregar dados de pré-visualização',
    },
    template_data: {
      recipient_name: '&lt;Primeiro nome&gt;',
    },
  },
};
